import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function GuardrailPill({ name, verdict }) {
    // verdict: 'pass' | 'warn' | undefined/anything else = muted
    const cls = verdict === "pass" ? "gpill--pass" : verdict === "warn" ? "gpill--warn" : "gpill--muted";
    const isMuted = verdict !== "pass" && verdict !== "warn";
    // In muted (pre-verdict) state, render "—" unconditionally — ignore any
    // carried-over note from a prior verdict so the placeholder reads cleanly.
    const verdictText = isMuted ? "—" : (verdict ?? "—").toUpperCase();
    return (_jsxs("div", { className: `gpill ${cls}`, title: !isMuted ? (verdict ?? "") : "", children: [_jsx("span", { className: "gpill__dot" }), _jsx("span", { className: "gpill__name", children: name }), _jsx("span", { className: "gpill__verdict", children: verdictText })] }));
}
//# sourceMappingURL=GuardrailPill.js.map